import $ from 'jquery';
import 'slick-carousel';

const breakpoint = 980;
const dotsClass = 'slick-dots-default';
const prevArrow = '<button type="button" class="icon-arrow-prev-circle"></button>';
const nextArrow = '<button type="button" class="icon-arrow-next-circle"></button>';
const prevArrowMagazine = `<a href="#" class="icon-arrow-prev-circle gtm-slider-area magazine-slide-button" onclick=""></a>`;
const nextArrowMagazine = `<a href="#" class="icon-arrow-next-circle gtm-slider-area magazine-slide-button" onclick=""></a>`;

export function init() {
  function Init3dSlider (event, slick) {
    const cur = $(slick.$slides[slick.currentSlide]);
    const next = cur.next();
    const prev = cur.prev();
    prev.addClass('slick-sprev');
    next.addClass('slick-snext');
    cur.removeClass('slick-snext').removeClass('slick-sprev');
    slick.$prev = prev;
    slick.$next = next;
  }
  function beforeChange3dSlider (event, slick, currentSlide, nextSlide) {
    const cur = $(slick.$slides[nextSlide]);
    slick.$prev.removeClass('slick-sprev');
    slick.$next.removeClass('slick-snext');
    const next = cur.next();
    const prev = cur.prev();
    prev.addClass('slick-sprev');
    next.addClass('slick-snext');
    slick.$prev = prev;
    slick.$next = next;
    cur.removeClass('slick-next').removeClass('slick-sprev');
  }
  const mainVisual = $('#mainVisualSlide');
  mainVisual.on('init', Init3dSlider);
  mainVisual.on('beforeChange', beforeChange3dSlider);
  mainVisual.slick({
    autoplay: true,
    mobileFirst: true,
    dots: true,
    autoplaySpeed: 4000,
    dotsClass: dotsClass,
    arrows: false,
    centerMode: true,
    slidesToShow: 1,
    centerPadding: "20px",
    responsive: [
      {
        breakpoint: breakpoint,
        settings: {
          centerPadding: "75px"
        }
      }
    ]
  });

  $("#pickupSlideSmall").slick({
    mobileFirst: true,
    arrows: false,
    autoplay: true,
    dots: true,
    autoplaySpeed: 4000,
    centerMode: true,
    centerPadding: "15%",
    dotsClass: dotsClass,
    responsive: [
      {
        breakpoint: breakpoint,
        settings: {
          centerPadding: "27%"
        }
      }
    ]
  });

  const newTopicsTab = $('#newTopicsTab').slick({
    mobileFirst: true,
    autoplay: false,
    arrows: false,
    dots: false,
    centerMode: false,
    variableWidth: true,
    slidesToShow: 8,
    infinite: false,
    swipe: false,
    asNavFor: '#newTopicsPanel'
  });
  const newTopicsPanel = $('#newTopicsPanel').slick({
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '#newTopicsTab'
  });
  newTopicsTab.find('.slick-slide button').on('click', function () {
    const index = $(this).closest('.slick-slide').attr('data-slick-index');
    newTopicsPanel.slick('slickGoTo', index);
  });
  newTopicsPanel.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
    const list = newTopicsTab.find('.slick-list');
    const tab = newTopicsTab.find('.slick-slide').eq(nextSlide);
    const listPosLeft = list.offset().left;
    const scrollLeft = list.scrollLeft();
    const scrollRight = scrollLeft + list.outerWidth();
    const tabPosLeft = tab.offset().left + scrollLeft - listPosLeft;
    const tabPosRight = tabPosLeft + tab.outerWidth();
    if (scrollLeft > tabPosLeft) {
      list.animate({scrollLeft: tabPosLeft}, 200);
    }
    if (scrollRight < tabPosRight) {
      list.animate({scrollLeft: tabPosRight - list.outerWidth()}, 200);
    }
  });

  const RankingTab = $('#RankingTab').slick({
    mobileFirst: true,
    autoplay: false,
    arrows: false,
    dots: false,
    centerMode: false,
    variableWidth: true,
    slidesToShow: 8,
    infinite: false,
    swipe: false,
    asNavFor: '#RankingPanel'
  });
  const RankingPanel = $('#RankingPanel').slick({
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '#RankingTab'
  });
  RankingTab.find('.slick-slide button').on('click', function () {
    const index = $(this).closest('.slick-slide').attr('data-slick-index');
    RankingPanel.slick('slickGoTo', index);
  });
  RankingPanel.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
    const list = RankingTab.find('.slick-list');
    const tab = RankingTab.find('.slick-slide').eq(nextSlide);
    const listPosLeft = list.offset().left;
    const scrollLeft = list.scrollLeft();
    const scrollRight = scrollLeft + list.outerWidth();
    const tabPosLeft = tab.offset().left + scrollLeft - listPosLeft;
    const tabPosRight = tabPosLeft + tab.outerWidth();
    if (scrollLeft > tabPosLeft) {
      list.animate({scrollLeft: tabPosLeft}, 200);
    }
    if (scrollRight < tabPosRight) {
      list.animate({scrollLeft: tabPosRight - list.outerWidth()}, 200);
    }
  });

  const slickTab = $('.slickTab');
  slickTab.each(function() {
    const group = $(this).attr('data-slick-group');
    const columnCount = parseInt($(this).attr('data-column-count'));
    $(this).slick({
      mobileFirst: true,
      autoplay: false,
      slidesToShow: columnCount,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      centerMode: true,
      centerPadding: 0,
      variableWidth: true,
      asNavFor: '.slickPanel[data-slick-group=' + group + ']',
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      responsive: [
        {
          breakpoint: breakpoint,
          settings: {
            arrows: false,
            speed: 0
          }
        }
      ]
    });
  });

  if (slickTab.attr('data-enable-tab-click')) {
    slickTab.on('click', function(e) {
      console.log(e, $(e.target).attr('data-slick-index'));
      $(this).slick('slickGoTo', $(e.target).parents('[data-slick-index]').attr('data-slick-index'));
    });
  }

  $('.slickPanel').each(function() {
    const columnCount = parseInt($(this).attr('data-column-count'));
    const group = $(this).attr('data-slick-group');
    $(this).slick({
      mobileFirst: true,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slickTab[data-slick-group=' + group + ']',
      responsive: [
        {
          breakpoint: breakpoint,
          settings: {
            centerMode: true,
            infinite: true,
            slidesToShow: columnCount,
            centerPadding: 0,
            slidesToScroll: columnCount,
            fade: false,
            speed: 0
          }
        }
      ]
    });
  });

  $('.slickTabPrev').each(function() {
    const group = $(this).attr('data-slick-group');
    const slickTab = $('.slickTab[data-slick-group=' + group + ']');
    const slickPanel = $('.slickPanel[data-slick-group=' + group + ']');
    const columnCount = slickPanel.attr('data-column-count');
    $(this).on('click', function() {
      slickTab.slick('slickGoTo', slickTab.slick('slickCurrentSlide') + parseInt(columnCount) + 1);
      slickPanel.slick('slickGoTo', slickPanel.slick('slickCurrentSlide') + parseInt(columnCount) + 1);
    });
  });

  $('.slickTabNext').each(function() {
    const group = $(this).attr('data-slick-group');
    const slickTab = $('.slickTab[data-slick-group=' + group + ']');
    const slickPanel = $('.slickPanel[data-slick-group=' + group + ']');
    const columnCount = slickPanel.attr('data-column-count');
    $(this).on('click', function () {
      slickTab.slick('slickGoTo', slickTab.slick('slickCurrentSlide') + parseInt(columnCount));
      slickPanel.slick('slickGoTo', slickPanel.slick('slickCurrentSlide') + parseInt(columnCount));
    });
  });

  $("#columnSlide").slick({
    mobileFirst: true,
    autoplay: true,
    arrows: false,
    dots: true,
    autoplaySpeed: 4000,
    centerMode: true,
    centerPadding: "15%",
    dotsClass: dotsClass,
    responsive: [
      {
        breakpoint: breakpoint,
        settings: {
          centerPadding: "30%"
        }
      }
    ]
  });

  const modelSlider = $('#modelSlide');
  modelSlider.on('init', Init3dSlider);
  modelSlider.on('beforeChange', beforeChange3dSlider);
  modelSlider.slick({
    autoplay: true,
    mobileFirst: true,
    dots: false,
    autoplaySpeed: 4000,
    dotsClass: dotsClass,
    arrows: false,
    centerMode: true,
    slidesToShow: 1,
    centerPadding: "20px",
    responsive: [
      {
        breakpoint: breakpoint,
        settings: {
          arrows: false,
          centerPadding: "180px",
          prevArrow: prevArrow,
          nextArrow: nextArrow,
        }
      }
    ]
  });

  const userScroll = $('.user-scroll');
  if (userScroll.length) {
    userScroll.each(function () {
      const userList = $(this).find('.user-scroll-list');
      const userListItems = userList.children('li');
      const userListWidth = userList.outerWidth();
      userList.attr('data-count', userListItems.length).css('animation-duration', userListWidth / 260 * 3 + 's');
      const clone = userList.clone().addClass('user-scroll-list-clone');
      $(this).prepend(clone.clone());
      $(this).append(clone.clone());
    });
    userScroll.addClass('user-scroll-init');
  }

  $('#pickupSlideSimple').slick({
    mobileFirst: true,
    arrows: false,
    autoplay: true,
    dots: true,
    dotsClass: dotsClass,
    autoplaySpeed: 4000,
    centerMode: true,
    slidesToShow: 1,
    centerPadding: "10%",
    responsive: [
      {
        breakpoint: breakpoint,
        settings: {
          centerPadding: "125px"
        }
      }
    ]
  });

  $('#presentSlide').slick({
    mobileFirst: true,
    arrows: false,
    autoplay: true,
    dots: true,
    dotsClass: dotsClass,
    autoplaySpeed: 4000,
    centerMode: true,
    slidesToShow: 1,
    centerPadding: "10%",
    responsive: [
      {
        breakpoint: breakpoint,
        settings: {
          centerPadding: "25px"
        }
      }
    ]
  });

  $('#hotTopicsSlide').slick({
    mobileFirst: true,
    autoplaySpeed: 4000,
    autoplay: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: '50px',
    dots: true,
    arrows: true,
    dotsClass: dotsClass,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [ /** PCÃ¥ÂÂ´Ã£ÂÂ®Ã¨Â¨Â­Ã¥Â®Â */
      {
        breakpoint: breakpoint,
        settings: {
          centerMode: false,
          slidesToScroll: 3,
          slidesToShow: 3,
          centerPadding: 0,
        }
      }
    ]
  });

  const magazineSlide = $('#magazineSlide');

  const magazineSlider = magazineSlide.slick({
    mobileFirst: true,
    autoplay: false,
    slidesToShow: 1,
    centerMode: true,
    arrows: true,
    variableWidth: true,
    dotsClass: dotsClass,
    prevArrow: prevArrowMagazine,
    nextArrow: nextArrowMagazine,
    rtl: true,
    initialSlide: getSliderPageIndex()
  });

  $('#magazineSlidePager').find('a').on('click', function (e) {
    e.preventDefault();
    const magazineSlide = $('#magazineSlide');

    const targetIndex = parseInt($(this).data('index'));
    magazineSlide.slick('slickGoTo', targetIndex);

    $('html, body').animate({
      scrollTop: magazineSlide.offset().top - $('#header').height() * 2
    }, 500);
  });

  const magazineDataLayer = {
    event:'evTracking',
    evCategory:'MAQUIAÃ¨Â©Â¦Ã£ÂÂÃ¨ÂªÂ­Ã£ÂÂ¿Ã£ÂÂ¹Ã£ÂÂ©Ã£ÂÂ¤Ã£ÂÂÃ£ÂÂ¼',
    evAction: '1',
    evLabel: $('title').text()
  };

  updateMagazineDataLayer(magazineDataLayer);

  magazineSlider.on('afterChange', function (slick, currentSlide){
    magazineDataLayer.evAction = (currentSlide.currentSlide + 1).toString(10);
    updateMagazineDataLayer(magazineDataLayer);

    dataLayer.push({
      'event': 'articleVirtualPV',
      'pageVirtual': 'Ã¨Â©Â¦Ã£ÂÂÃ¨ÂªÂ­Ã£ÂÂ¿Ã£ÂÂ¹Ã£ÂÂ©Ã£ÂÂ¤Ã£ÂÂÃ£ÂÂ¼',
      'VPVpath': location.pathname
    });
  });

  function updateMagazineDataLayer(dataLayer) {
    $('.magazine-slide-button').each(function () {
      $(this).attr('onclick', `dataLayer.push(${JSON.stringify(dataLayer)})`);
    });
  }

  function getUrlQuery() {
    const vars = [];
    const hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(let i = 0; i <hashes.length; i++) {
      const hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
  }

  function getSliderPageIndex() {
    const query = getUrlQuery()['page'];
    const page = parseInt(query);
    const totalPageCount = magazineSlide.find('img').length;

    if (typeof query === 'undefined' || totalPageCount < page) {
      return 0;
    }

    return page;
  }

  infinitiSlideInit();
}

export function infinitiSlideInit() {
  $('.js-slide-3column').not('.slick-initialized').slick({
    mobileFirst: true,
    autoplaySpeed: 4000,
    autoplay: true,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: '20px',
    dots: true,
    arrows: false,
    variableWidth: true,
    dotsClass: dotsClass,
    responsive: [
      {
        breakpoint: breakpoint,
        settings: {
          centerMode: false,
          slidesToScroll: 3,
          centerPadding: 0,
        }
      }
    ]
  });

  $('.js-slide-5column').not('.slick-initialized').slick({
    mobileFirst: true,
    autoplaySpeed: 4000,
    autoplay: true,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: '20px',
    dots: true,
    dotsClass: dotsClass,
    arrows: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: breakpoint,
        settings: {
          centerMode: true,
          slidesToScroll: 3,
          centerPadding: '90px',
        }
      }
    ]
  });

  $('.js-article-related-articles-list').not('.slick-initialized').slick({
    mobileFirst: true,
    autoplay: false,
    dots: false,
    arrows: false,
    swipe: false,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
      {
        breakpoint: breakpoint,
        settings: {
          arrows: true,
        }
      }
    ]
  });

  $('.js-pickup-middle-slider').not('.slick-initialized').slick({
    mobileFirst: true,
    arrows: false,
    autoplay: true,
    dots: true,
    dotsClass: dotsClass,
    autoplaySpeed: 4000,
    centerMode: true,
    slidesToShow: 1,
    centerPadding: "10%",
    responsive: [
      {
        breakpoint: breakpoint,
        settings: {
          centerPadding: "230px"
        }
      }
    ]
  });

  const selector = {
    wrap:     '.js-inarticle-slider',
    img:      '.js-inarticle-slider__img',
    text:     '.js-inarticle-slider__text',
    textElm:  '.js-inarticle-slider__text__item',
    thumb:    '.js-inarticle-slider__thumb'
  };

  $(`${selector.wrap}:not(.is-init)`).each(function (){
    const $SliderImg = $(this).find(selector.img);
    const $SliderText = $(this).find(selector.text);
    const $SliderThumb = $(this).find(selector.thumb);

    const sliderOption = {
      img: {
        mobileFirst: true,
        speed: 600,
        dots: true,
        dotsClass: dotsClass,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        asNavFor: $SliderThumb.length > 0 ? $SliderThumb : null,
        responsive: [
          {
            breakpoint: breakpoint,
            settings: {
              arrows: true,
            }
          }
        ]
      },
      thumb: {
        mobileFirst: true,
        speed: 600,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
        focusOnSelect: true,
        asNavFor: $SliderImg,

        responsive: [
          {
            breakpoint: breakpoint,
            settings: {
              slidesToShow: 8
            }
          }
        ]
      }
    };

    try {
      $SliderImg.not('.slick-initialized').slick(sliderOption.img);
      if (sliderOption.img.asNavFor !== null) $SliderThumb.slick(sliderOption.thumb);
      $(this).addClass('is-init');
    } catch(e) {
      console.error(e.stack);
    }

    $SliderImg.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      $SliderText.find(selector.textElm).removeClass('is-active');
      $SliderText.find(selector.textElm).eq(nextSlide).addClass('is-active');
    });
  });

  $('.article-cosme-list-block[data-list-type="slider"] .article-cosme-list').not('.slick-initialized').slick({
    mobileFirst: true,
    autoplay: false,
    centerMode: true,
    dots: true,
    arrows: true,
    variableWidth: true,
    dotsClass: dotsClass,
    prevArrow: prevArrow,
    nextArrow: nextArrow
  });
}
